/**
 * Static city metadata for instant skeleton UI.
 */
export type CityPreview = {
  id: string;
  name: string;
  tagline: string;
  imagePosition: string;
};

export const FEATURED_CITY_PREVIEWS: CityPreview[] = [
  {
    id: 'madrid',
    name: 'Madrid',
    tagline: 'Planes en Madrid',
    imagePosition: '50% 40%',
  },
  {
    id: 'valencia',
    name: 'Valencia',
    tagline: 'Planes en Valencia',
    imagePosition: '50% 45%',
  },
  {
    id: 'barcelona',
    name: 'Barcelona',
    tagline: 'Planes en Barcelona',
    imagePosition: '50% 35%',
  },
  {
    id: 'miami',
    name: 'Miami',
    tagline: 'Planes en Miami',
    imagePosition: '50% 40%',
  },
];

export const FEATURED_CITY_IDS = FEATURED_CITY_PREVIEWS.map((city) => city.id);

export const CITY_PREVIEW_BY_ID = Object.fromEntries(
  FEATURED_CITY_PREVIEWS.map((city) => [city.id, city]),
) as Record<string, CityPreview>;

/** Placeholder plan photos while the API loads (local assets). */
export const PLAN_SKELETON_IMAGES = [
  '/images/home-redesign/chat/plans/0-terrace.jpg',
  '/images/home-redesign/chat/plans/1-bike.jpg',
  '/images/home-redesign/chat/plans/2-barre.jpg',
  '/images/home-redesign/chat/plans/3-korean.jpg',
  '/images/home-redesign/chat/plans/4-sunset.jpg',
] as const;

export function cityPreviewFromSlug(slug: string | undefined): CityPreview | null {
  if (!slug) return null;
  return CITY_PREVIEW_BY_ID[slug.toLowerCase()] ?? null;
}

export function cityDisplayNameFromSlug(slug: string | undefined): string {
  const preview = cityPreviewFromSlug(slug);
  if (preview) return preview.name;
  if (!slug) return '';
  return slug
    .split('-')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}
